// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__O8vtu","additionalInfo":"AgreementModal_additionalInfo__AKqkZ"};